import { BASE_URl } from '@/api/index'

interface ResponseData {
  result: string
  panels: {
    hid: string
    address: string
    mzk: number
  }[]
}

export const getIntercoms = async () => {
  const res = await fetch(`${BASE_URl}/getPanels.php`, {
    method: 'GET',
  })
  if (!res.ok)
    throw new Error(
      'Не получилось получить данные с сервера. Попробуйте перезагрузить страницу.',
    )
  return transformIntercoms(await res.json())
}

const transformIntercoms = (data: ResponseData): Intercom[] => {
  return data.panels.map((intercom) => ({
    houseId: intercom.hid,
    city: intercom.mzk === 1 ? 'Междуреченск' : 'Мыски',
    address: intercom.address.split(', ').slice(1).join(', '),
  }))
}

interface Intercom {
  houseId: string
  city: string
  address: string
}
